// BlackbirdLanding.tsx (Unified Grid, full-height left column, single-page fit)
// One outer CSS grid (3 rows x 3 cols). Left column spans rows 2-3.

import { motion } from "framer-motion";
import { Helmet } from "react-helmet";

// Components
import CursorFollower from "./components/CursorFollower";
import AnimatedBorder from "./components/AnimatedBorder";
// Content
import Header from "./content/Header";
import LeftColumn from "./content/LeftColumn";
import CenterContent from "./content/CenterContent";
import RightStack from "./content/RightStack";
import HistogramWrap from "./content/HistogramWrap";
import CornerCardWrap from "./content/CornerCardWrap";

export default function BlackbirdLanding() {
  return (
    <>
      <Helmet>
        <title>Blackbird - Clearance Pending</title>
        <meta name="description" content="Blackbird operates at the edge of possibility — where innovation is silent, speed is survival, and compromise is failure. Subscribe for updates and announcements." />
        <meta name="keywords" content="blackbird, innovation, technology, coming soon, clearance, classified" />
        <meta name="author" content="Blackbird" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Blackbird - Clearance Pending" />
        <meta property="og:description" content="Blackbird operates at the edge of possibility — where innovation is silent, speed is survival, and compromise is failure." />
        <meta property="og:site_name" content="Blackbird" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Blackbird - Clearance Pending" />
        <meta name="twitter:description" content="Blackbird operates at the edge of possibility — where innovation is silent, speed is survival, and compromise is failure." />
        
        {/* Favicon */}
        <link rel="icon" type="image/x-icon" href="/favicon.ico" />
        
        {/* Theme */}
        <meta name="theme-color" content="#000000" />
        <meta name="msapplication-TileColor" content="#000000" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://blackbird.ai" />
      </Helmet>
      
      <div className="min-h-screen bg-black text-white font-sans px-6 pt-6 pb-5 md:px-12 md:pt-12 flex flex-col items-center justify-center">
        <CursorFollower />
      {/* 3x3 cockpit grid */}
      <AnimatedBorder delay={0.2} duration={1.5} className="w-full grow flex flex-col lg:grid lg:grid-cols-[240px_1fr_130px] xl:grid-cols-[240px_1fr_240px] lg:grid-rows-[120px_1fr_200px]">
        {/* Row 1: Header across all columns */}
        <Header className="col-[1/_-1] row-[1]" />

        {/* Left column: rows 2-3 (full height below header) */}
        <LeftColumn className="col-[1] row-[2/span_2] opacity-40" />

        {/* Center main content (row 2, col 2) */}
        <CenterContent />

        {/* Right: radar + vertical scale (row 2, col 3) */}
        <RightStack className="col-[3] row-[2] opacity-40" />

        {/* Bottom: histogram (row 3, col 2) */}
        <HistogramWrap className="col-[2] row-[3] opacity-40" />

        {/* Bottom: corner card (row 3, col 3) */}
        <CornerCardWrap className="col-[3] row-[3]" />

      </AnimatedBorder>
      
      {/* Copyright */}
      <motion.div 
        className="text-white/40 text-xs tracking-widest uppercase pt-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0, ease: "easeInOut" }}
      >
        © {new Date().getFullYear()} Blackbird. All rights reserved.
      </motion.div>
      </div>
    </>
  );
}